


















































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ModulesHelper from '@core/services/modules.helper';
import Avatar from '@shared/components/avatar/avatar.vue';
import BpcRouterLink from '@shared/components/bpc-router-link.vue';

@Component({
  name: 'bpc-header-user-area',
  components: {
    VuePerfectScrollbar,
    'bpc-avatar': Avatar,
    BpcRouterLink,
  },
})
export default class Header extends Vue {
  get isRoleContact() {
    return (
      this.$authorizationService.hasRole('contact') ||
      this.$authorizationService.hasRole('contact_read')
    );
  }

  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get contactType(): string {
    return this.$store.getters['auth/profile']({ tenantId: this.tenantId })?.contact_type || null;
  }

  get avatar(): string {
    const avatar = this.$store.getters['auth/profile']({ tenantId: this.tenantId })?.avatar || null;
    if (avatar instanceof Array) {
      return avatar[0].url;
    } else if (avatar instanceof Object) {
      return avatar.url;
    } else {
      return avatar;
    }
  }

  get lang() {
    return this.$store.getters['auth/userLang'] || this.$i18n.locale;
  }

  get profileName(): string {
    return (
      this.$store.getters['auth/profile']({ tenantId: this.tenantId })?.name ||
      this.$store.getters['auth/userName']
    );
  }

  get profileEmail(): string {
    return this.$store.getters['auth/profile']({ tenantId: this.tenantId })?.email || '';
  }

  get showMenuEntries(): string[] {
    return this.contactType === 'individual'
      ? this.$store.getters['centerSettings/centerSettings']?.show_menu_entries || []
      : this.$store.getters['centerSettings/centerSettings']?.show_menu_entries_for_organization ||
          [];
  }

  get allowAccessClientSection(): boolean {
    return this.$store.getters['centerSettings/centerSettings']?.allow_access_client_section;
  }

  public menuContact = [];
  public get filteredMenuContact() {
    this.menuContact = [
      {
        href: this.$clientRouter.getClientUrl(`profile`),
        icon: 'lnr-home',
        name: 'dashboard',
        title: this.$t('global.profile.menu.home.title'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/bookings`),
        icon: 'lnr-calendar-full',
        name: 'bookings',
        title: this.$t('global.profile.menu.bookings.title'),
        description: this.$t('global.profile.menu.bookings.description'),
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('bookings'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/my-booking-requests`),
        icon: 'lnr-calendar-full',
        name: 'bookings',
        title: this.$t('global.profile.menu.my_booking_requests.title'),
        description: this.$t('global.profile.menu.my_booking_requests.description'),
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
        permissions: ['manage_bookings', 'manage_public_bookings'], // TODO: JJFC check this permissions
        hidden: !this.showMenuEntries.includes('my-booking-requests'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/new-booking`),
        icon: 'lnr-plus-circle',
        bgVariant: 'success',
        textVariant: 'white',
        // onlyGrid: true,
        name: 'book-resource',
        title: this.$t('global.profile.menu.book_resource.title'),
        description: this.$t('global.profile.menu.book_resource.description'),
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
        hidden:
          !this.showMenuEntries.includes('book-resource') ||
          this.$modulesService.hasModuleActivated(ModulesHelper.ONLINE_BOOKING_V2_MODULE_NAME),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/online-booking`),
        icon: 'lnr-plus-circle',
        bgVariant: 'success',
        textVariant: 'white',
        // onlyGrid: true,
        name: 'book-resource',
        title: this.$t('global.profile.menu.book_resource.title'),
        description: this.$t('global.profile.menu.book_resource.description'),
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
        hidden:
          !this.showMenuEntries.includes('book-resource') ||
          !this.$modulesService.hasModuleActivated(ModulesHelper.ONLINE_BOOKING_V2_MODULE_NAME),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/enrollments`),
        icon: 'lnr-heart-pulse',
        name: 'enrollments',
        title: this.$t('global.profile.menu.enrollments.title'),
        description: this.$t('global.profile.menu.enrollments.description'),
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('enrollments'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/activities`),
        icon: 'lnr-magnifier',
        bgVariant: 'primary',
        textVariant: 'white',
        // onlyGrid: true,
        name: 'activities',
        title: this.$t('global.profile.menu.search_activity.title'),
        description: this.$t('global.profile.menu.search_activity.description'),
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('activities'),
      },
      // {
      //   href: this.$clientRouter.getClientUrl(`profile/activities`,
      //   icon: 'lnr-magnifier',
      //   onlyBreadcrumbs: true,
      //   name: 'activity-details',
      //   title: this.$t('global.profile.menu.activity_details.title'),
      //   description: this.$t('global.profile.menu.activity_details.description'),
      //   module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      // },
      {
        href: this.$clientRouter.getClientUrl(`profile/subscriptions`),
        icon: 'lnr-license',
        name: 'subscriptions',
        title: this.$t('global.profile.menu.subscriptions.title'),
        description: this.$t('global.profile.menu.subscriptions.description'),
        module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('subscriptions'),
      },
      {
        href: this.$clientRouter.getClientUrl(`web/${this.lang}/sales/entries`),
        icon: 'lnr-tag',
        name: 'entries',
        title: this.$t('global.profile.menu.entries.title'),
        description: this.$t('global.profile.menu.entries.description'),
        module: ModulesHelper.ENTRIES_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('entries-available'),
        refresh: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`web/${this.lang}/profile/my-entries`),
        icon: 'lnr-tag',
        name: 'my-entries',
        title: this.$t('global.show_menu_entries_my_entries_title'),
        description: this.$t('global.show_menu_entries_my_entries_description'),
        module: ModulesHelper.ENTRIES_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('entries'),
        refresh: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/contracts`),
        icon: 'lnr-inbox',
        name: 'contracts',
        title: this.$t('global.profile.menu.contracts.title'),
        description: this.$t('global.profile.menu.contracts.description'),
        module: ModulesHelper.CONTRACTS_DOCUMENTS_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('contracts'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/invoices`),
        icon: 'lnr-book',
        name: 'invoices',
        title: this.$t('global.profile.menu.invoices.title'),
        description: this.$t('global.profile.menu.invoices.description'),
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('invoices'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/contact`),
        icon: 'lnr-user',
        name: 'contact',
        title: this.$t('global.profile.menu.my_contact_details.title'),
        description: this.$t('global.profile.menu.my_contact_details.description'),
        hidden: !this.showMenuEntries.includes('contact'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/edit-password`),
        icon: 'lnr-lock',
        name: 'edit-password',
        title: this.$t('global.profile.menu.edit_password.title'),
        description: this.$t('global.profile.menu.edit_password.description'),
        hidden: !this.showMenuEntries.includes('edit-password'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/family`),
        icon: 'lnr-users',
        name: 'family',
        title: this.$t('global.profile.menu.my_family.title'),
        description: this.$t('global.profile.menu.my_family.description'),
        hidden: !this.showMenuEntries.includes('family'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/mailbox`),
        icon: 'lnr-envelope',
        name: 'mailbox',
        title: this.$t('global.profile.menu.messages.title'),
        description: this.$t('global.profile.menu.messages.description'),
        hidden: !this.showMenuEntries.includes('mailbox'),
      },
    ];

    return this.menuContact.filter(item => {
      return (
        !item.hidden &&
        (item.module
          ? this.$modulesService.hasModuleActivated(item.module)
          : item.modules
          ? this.$modulesService.hasSomeModuleActivated(item.modules)
          : true) &&
        (item.permissions ? this.$authorizationService.hasPermissions(item.permissions) : true)
      );
    });
  }
}
